module.exports = __webpack_public_path__ + "static/media/2.10f0bc64.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/special/2.png
// module id = 1548
// module chunks = 0